import React, { useMemo } from 'react';
var ModalBody = function (_a) {
    var className = _a.className, children = _a.children, _b = _a.isScroll, isScroll = _b === void 0 ? true : _b, isModalAdmin = _a.isModalAdmin;
    var renderContent = useMemo(function () {
        var classNameResult = 'gr-modal-body ' +
            (isModalAdmin ? 'gr-modal-body-admin ' : '') +
            (isScroll ? 'custom-scroll ' : ' ') +
            (className ? className : '');
        return React.createElement("div", { className: classNameResult }, children);
    }, [children, className, isScroll]);
    return React.createElement(React.Fragment, null, renderContent);
};
export { ModalBody };
//# sourceMappingURL=ModalBody.js.map